import React from "react";
import { useTranslation } from "react-i18next";


const AboutCabil = () => {
  const { t } = useTranslation();
  return (
  <section className="py-20 bg-gray-50 text-center">
    <h2 className="text-5xl font-bold text-gray-800 mb-8">{t("aboutCabil.title")}</h2>
    <p className="max-w-3xl mx-auto text-center text-gray-600 mb-8">
   {t("aboutCabil.description1")}
<br /><br />
{t("aboutCabil.description2")}
    </p>

    <p className="max-w-3xl mx-auto text-center text-sm text-gray-500 mb-12">
      {t("aboutCabil.tradingNamePrefix")} <strong>{t("aboutCabil.tradingNameBold")}</strong>{t("aboutCabil.tradingNameSuffix")}
    </p>

  </section>
  );
};

export default AboutCabil;
